export const SINGLE_DRAFTS_FEATURE_KEY = 'single-drafts';
